import _isFunction from "lodash/isFunction";
export const getFieldObject = (field, formik) => _isFunction(field) ? field(formik) : field;